import React, { useState, useEffect } from "react";

export default function MathChallenge() {
    const [num1, setNum1] = useState(0);
    const [num2, setNum2] = useState(0);
    const [operator, setOperator] = useState("+");
    const [answer, setAnswer] = useState("");
    const [score, setScore] = useState(0);
    const [timeLeft, setTimeLeft] = useState(30);
    const [gameActive, setGameActive] = useState(false);
    const [feedback, setFeedback] = useState("");

    const generateQuestion = () => {
        const operators = ["+", "-", "*"];
        const op = operators[Math.floor(Math.random() * operators.length)];
        const n1 = Math.floor(Math.random() * 20) + 1;
        const n2 = Math.floor(Math.random() * 20) + 1;

        setNum1(n1);
        setNum2(n2);
        setOperator(op);
        setAnswer("");
        setFeedback("");
    };

    const startGame = () => {
        setScore(0);
        setTimeLeft(30);
        setGameActive(true);
        generateQuestion();
    };

    useEffect(() => {
        if (gameActive && timeLeft > 0) {
            const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
            return () => clearTimeout(timer);
        } else if (timeLeft === 0 && gameActive) {
            setGameActive(false);
        }
    }, [timeLeft, gameActive]);

    const checkAnswer = () => {
        let correct = 0;
        switch (operator) {
            case "+": correct = num1 + num2; break;
            case "-": correct = num1 - num2; break;
            case "*": correct = num1 * num2; break;
            default: correct = 0;
        }

        if (parseInt(answer) === correct) {
            setScore(score + 1);
            setFeedback("✓");
            setTimeout(() => generateQuestion(), 500);
        } else {
            setFeedback("✗");
            setTimeout(() => setFeedback(""), 800);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter" && answer && gameActive) {
            checkAnswer();
        }
    };

    if (!gameActive && timeLeft > 0) {
        return (
            <div style={{
                textAlign: "center",
                padding: "1rem",
                color: "#e5e7eb",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                boxShadow: "0 0 25px rgba(0,255,200,0.15)"
            }}>
                <h4 style={{color:"#facc15", marginBottom:"0.5rem"}}>
                    <i className="fas fa-calculator" style={{marginRight:"6px"}}></i> Math Challenge
                </h4>
                <p style={{fontSize:"0.85rem", marginBottom:"1rem"}}>Risolvi quante più operazioni in 30 secondi!</p>
                <button
                    onClick={startGame}
                    style={{
                        background:"linear-gradient(135deg,#facc15,#ca8a04)",
                        border:"none",
                        color:"#000",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-play" style={{marginRight:"6px"}}></i> Inizia
                </button>
            </div>
        );
    }

    if (timeLeft === 0) {
        return (
            <div style={{
                textAlign: "center",
                padding: "1.5rem",
                color: "#e5e7eb",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                boxShadow: "0 0 25px rgba(0,255,200,0.15)"
            }}>
                <h4 style={{color:"#facc15", marginBottom:"1rem"}}>
                    <i className="fas fa-trophy" style={{marginRight:"6px"}}></i> Tempo Scaduto!
                </h4>
                <p style={{fontSize:"1.5rem", fontWeight:"700", color:"#22c55e", marginBottom:"1rem"}}>
                    Punteggio: {score}
                </p>
                <p style={{fontSize:"0.9rem", marginBottom:"1.5rem"}}>
                    {score >= 15 && "🎉 Eccezionale! Sei un fulmine!"}
                    {score >= 10 && score < 15 && "👍 Ottimo risultato!"}
                    {score >= 5 && score < 10 && "💪 Buon lavoro, continua così!"}
                    {score < 5 && "🔢 La pratica rende perfetti!"}
                </p>
                <button
                    onClick={startGame}
                    style={{
                        background:"linear-gradient(135deg,#16a34a,#065f46)",
                        border:"none",
                        color:"#fff",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-redo" style={{marginRight:"6px"}}></i> Rigioca
                </button>
            </div>
        );
    }

    return (
        <div style={{
            textAlign: "center",
            padding: "1.5rem",
            color: "#e5e7eb",
            background: "rgba(255,255,255,0.05)",
            borderRadius: "1rem",
            boxShadow: "0 0 25px rgba(0,255,200,0.15)"
        }}>
            <div style={{display:"flex", justifyContent:"space-between", marginBottom:"1rem", fontSize:"0.85rem"}}>
                <span style={{color:"#94a3b8"}}>⏱️ {timeLeft}s</span>
                <span style={{color:"#22c55e", fontWeight:"700"}}>🎯 {score} punti</span>
            </div>

            <div style={{
                fontSize:"2.5rem",
                fontWeight:"700",
                color:"#facc15",
                marginBottom:"1.5rem",
                fontFamily:"monospace"
            }}>
                {num1} {operator} {num2} = ?
            </div>

            <div style={{position:"relative", marginBottom:"1rem"}}>
                <input
                    type="number"
                    value={answer}
                    onChange={(e) => setAnswer(e.target.value)}
                    onKeyPress={handleKeyPress}
                    autoFocus
                    style={{
                        width:"100%",
                        padding:"0.8rem",
                        borderRadius:"0.5rem",
                        border:"2px solid rgba(255,255,255,0.1)",
                        background:"rgba(255,255,255,0.05)",
                        color:"#fff",
                        fontSize:"1.2rem",
                        textAlign:"center",
                        outline:"none"
                    }}
                    placeholder="Scrivi la risposta..."
                />
                {feedback && (
                    <span style={{
                        position:"absolute",
                        right:"10px",
                        top:"50%",
                        transform:"translateY(-50%)",
                        fontSize:"1.5rem",
                        color: feedback === "✓" ? "#22c55e" : "#ef4444"
                    }}>
                        {feedback}
                    </span>
                )}
            </div>

            <button
                onClick={checkAnswer}
                disabled={!answer}
                style={{
                    background: answer ? "linear-gradient(135deg,#2563eb,#1e40af)" : "rgba(255,255,255,0.1)",
                    border:"none",
                    color:"#fff",
                    fontWeight:"700",
                    padding:"0.6rem 1.2rem",
                    borderRadius:"0.5rem",
                    cursor: answer ? "pointer" : "not-allowed",
                    opacity: answer ? 1 : 0.5,
                    width:"100%"
                }}
            >
                <i className="fas fa-check" style={{marginRight:"6px"}}></i> Conferma
            </button>
        </div>
    );
}